import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  schoolsList: {
    data: [],
    total: 0,
  },
};

const schoolsSlice = createSlice({
  name: "schools",
  initialState,
  reducers: {
    setSchoolsList: (state, action) => {
      state.schoolsList = action.payload;
    },
  },
});

export const { setSchoolsList } = schoolsSlice.actions;
export default schoolsSlice.reducer;